import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningHook } from '../components/OpeningHook';
import { Problem } from '../components/Problem';
import { FailedMethods } from '../components/FailedMethods';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { Proof } from '../components/Proof';
import { TrustSection } from '../components/TrustSection';
import { FAQ } from '../components/FAQ';
import { PriceBlock } from '../components/PriceBlock';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-cream selection:bg-periwinkle/30" data-id="element-189">
      <Hero data-id="element-190" />
      <OpeningHook data-id="element-191" />
      <Problem data-id="element-192" />
      <FailedMethods data-id="element-193" />
      <UniqueMechanism data-id="element-194" />
      <WhatYouGet data-id="element-195" />
      <WhoIsFor data-id="element-196" />
      <HowItWorks data-id="element-197" />
      <Proof data-id="element-198" />
      <TrustSection data-id="element-199" />
      <FAQ data-id="element-200" />
      <PriceBlock data-id="element-201" />
      <FinalCTA data-id="element-202" />
      <Footer data-id="element-203" />
    </main>;
}